import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  
    getUserData as getUserDataApi,
    getMainAccount as getMainAccountApi,
    getgoldsoldvalue as getgoldsoldvalueApi,
    getGoldWeigth as getGoldWeigthApi,
    getOutstanding as getOutstandingApi,
    getShipment as getShipmentApi,
    getShipmentOrder as getShipmentOrderApi,
    getVendorPending as getVendorPendingApi,
    getTemp as getTempApi,
    getManager as getManagerApi
} from "../../helpers/backend_helper";
 
import 'react-toastify/dist/ReactToastify.css'; 

//dashbord
export const getUserData = createAsyncThunk("dashbord/userData", async () => {
    try {
        const response = getUserDataApi();
        return response;
    } catch (error) {
        return error;
    }
});
export const getMainAccount = createAsyncThunk("dashbord/mainAccount", async () => {
    try {
        const response = getMainAccountApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const getgoldsoldvalue = createAsyncThunk("dashbord/getgoldsoldvalue",async()=>{
    try{
        const response = getgoldsoldvalueApi();
        return response;
    }catch (error) {
        return error;
    }
})

export const getGoldWeigth = createAsyncThunk("dashbord/getGoldWeigth",async()=>{
    try{
        const response = getGoldWeigthApi()
        return response
    }catch (error) {
        return error;
    }
})


export const getOutstanding = createAsyncThunk("dashbord/getOutstanding",async()=>{
    try{
     const response = getOutstandingApi();
     return response
    }catch(error){
        return error
    }
})


export const getShipment = createAsyncThunk("dashbord/shipment ", async () => {
    try{
        const response = await getShipmentApi();
    return response.data ; 
    }catch(error){
        return error
    }
}) 


export const getShipmentOrder = createAsyncThunk("dashbord/shipmentOrder", async () => {
    try{
        const response = await getShipmentOrderApi(); 
    return response.data ; 
    }catch(error){
        return error
    }
}) 

export const getVendorPending = createAsyncThunk("dashbord/getVendorPending",async()=>{
    try{
        const response = await getVendorPendingApi()
        return response.data

    }catch(error){
        return error
    }
})

export const getTemp = createAsyncThunk("dashbord/getTemp",async()=>{
    try{
        const response = await getTempApi()
        return response.data
    }catch(error){
        return error
    }
})

export const getManager = createAsyncThunk("dashbord/getManager",async(country?:any)=>{
    try{
        const response = await getManagerApi(country)
        return response.data
    }catch(error){
        return error
    }
})










 